import { FormShowTemplate } from 'framework/form';
import { ShowSection } from 'framework/ui/layout';
import { EditableListFormShowTemplate } from 'framework/list';
import { useProjectDataContext } from '../../context/ProjectDataContext';
import ProjectPlannedLeavesList from './ProjectPlannedLeavesList';
import { useShowContext } from 'framework/show';
import useProjectPlannedLeavesService, { PlannedLeavesFormData } from './useProjectPlannedLeavesService';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS } from '../../constants';
import { useProjectSecurityContext } from '../../context/ProjectSecurityContext';
import { TeamShowType } from '../types';
import { useApolloClient } from '@apollo/client/react';
import { GET_TEAM_TAB_DATA } from '../graphql/teamQueries';

const ProjectPlannedLeavesLayout = () => {
  const { data: project } = useProjectDataContext();
  const { data, setData } = useShowContext<TeamShowType>();
  const { isAccessGranted } = useProjectSecurityContext();
  const { getPlannedLeavesValidationSchema, submitPlannedLeaves } = useProjectPlannedLeavesService();
  const client = useApolloClient();
  const hasProjectBudget = !!project?.budget?.endDate && project?.budget?.billingType !== 'LEGACY';

  const canViewPlannedLeaves =
    isAccessGranted(ACCESS_INFO_SECTIONS.TEAM_PLANNED_LEAVE, ACCESS_INFO_ACTIONS.VIEW) ||
    isAccessGranted(ACCESS_INFO_SECTIONS.TEAM_PLANNED_LEAVE, ACCESS_INFO_ACTIONS.MANAGE);

  const submitFormFunc = async (values: PlannedLeavesFormData) => submitPlannedLeaves(project.id, values);

  const getDataFunc = async () => ({
    teamPlannedLeaves: data.getData()?.teamPlannedLeaves || [],
  });

  const handleReloadData = async () => {
    const response = await client.query<{ baseProject: TeamShowType }>({
      query: GET_TEAM_TAB_DATA,
      variables: { id: project.id.toString() },
    });

    if (response.data?.baseProject) {
      setData?.(response.data.baseProject);
    }
  };

  if (!canViewPlannedLeaves) {
    return null;
  }

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      getValidationSchemaFunc={getPlannedLeavesValidationSchema}
      fieldsExceptions={{
        hasProjectBudget,
        projectEndDate: hasProjectBudget ? project.budget?.endDate || null : null,
      }}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        message: 'You are awesome! Planned leaves have been successfully updated.',
        execute: handleReloadData,
      }}
      getDataFunc={getDataFunc}
    >
      <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
        <EditableListFormShowTemplate listSource="teamPlannedLeaves">
          <ProjectPlannedLeavesList />
        </EditableListFormShowTemplate>
      </ShowSection>
    </FormShowTemplate>
  );
};

export default ProjectPlannedLeavesLayout;
